import { Platform } from 'react-native';

export const usePushNotificationPermissionPrimerEnabled = () => {
  return { canEnablePushNotificationPrimer: Platform.OS !== 'web' };
};
